// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-validation-summary',
    created() {
        this.$form = utils.findForm(this);
    },
    methods: {
        hasErrors(data) {
            //Check
            if (data === undefined) {
                return false;
            }
            //Vars
            let tHasError = false;
            //Run
            Object.keys(data).forEach(e => {
                if (e.startsWith("$") && !data[e].isValid) {
                    tHasError = true;
                }
                ;
            });
            return tHasError;
        },
        filterErrors(data) {
            let tErrors = [];
            if (data === undefined) {
                return tErrors;
            }
            Object.keys(data).forEach(e => {
                if (e.startsWith("$") && !data[e].isValid) {
                    tErrors.push(data[e]);
                }
                ;
            });
            return tErrors;
        },
    }
});
// #endregion
